// removed by extract-text-webpack-plugin
module.exports = {"featured_item":"slider_featured_item_2tykG","featured_image":"slider_featured_image_1KtpM","featured_caption":"slider_featured_caption_KOEFh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/NewsSlider/slider.css
// module id = 324
// module chunks = 0